import withReadyOnlyAbility from '../ReadOnlyAbilityWrapper';
import DatePicker from './index';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(withReadyOnlyAbility(DatePicker));
